(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FilecoinJs", [], factory);
	else if(typeof exports === 'object')
		exports["FilecoinJs"] = factory();
	else
		root["FilecoinJs"] = factory();
})(window, function() {
return 